<label
  [htmlFor]="id"
  *ngIf="props.label"
  [ngClass]="{
    'ng-error': formControl.invalid,
    'ng-touched': formControl.touched
  }"
  >{{ props.label }}<ng-container *ngIf="props.required">*</ng-container></label
>
<mat-radio-group
  [formControl]="formControl"
  [formlyAttributes]="field"
  [required]="required"
  [tabindex]="props.tabindex"
  [id]="id"
  [formControl]="formControl"
  [ngClass]="{ 'radio-horizontal': props.orientation === 'horizontal', }"
>
  <mat-radio-button
    *ngFor="
      let option of props.options | formlySelectOptions : field | async;
      let i = index
    "
    [id]="id + '_' + i"
    [color]="props.color"
    [labelPosition]="props.labelPosition || 'after'"
    [disabled]="option.disabled"
    [value]="option.value"
  >
    {{ option.label }}
  </mat-radio-button>
</mat-radio-group>
<mat-error *ngIf="formControl.touched">
  <formly-validation-message [field]="field"></formly-validation-message>
</mat-error>
